var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShreder2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 124,
    viewBox: "0 0 122 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Large Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    d: "M13.5735 61.5151C13.5735 71.0086 16.3886 80.2889 21.6629 88.1825C26.9373 96.0761 34.4338 102.228 43.2047 105.861C51.9755 109.494 61.6267 110.445 70.9378 108.593C80.2489 106.741 88.8017 102.169 95.5146 95.4563C102.228 88.7433 106.799 80.1906 108.651 70.8795C110.503 61.5684 109.553 51.9172 105.92 43.1463C102.287 34.3755 96.1344 26.8789 88.2409 21.6046C80.3473 16.3303 71.067 13.5151 61.5735 13.5151",
    stroke: "#3030AD",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_2",
    d: "M119.956 46.4709C116.884 35.0083 110.483 24.714 101.561 16.8896C92.6388 9.06524 81.5969 4.06225 69.8316 2.51331C58.0662 0.964369 46.1058 2.93905 35.4627 8.18763C24.8196 13.4362 15.9719 21.723 10.0385 32C4.10504 42.277 1.35234 54.0827 2.12846 65.9242C2.90459 77.7656 7.1747 89.111 14.3988 98.5257C21.6229 107.94 31.4765 115.001 42.7136 118.816C53.9507 122.63 66.0666 123.027 77.5291 119.956",
    stroke: "#EBEBF9",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "shredder"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M65.3916 43.6968H47.5734C46.8705 43.6968 46.3007 44.2666 46.3007 44.9695C46.3007 45.6724 46.8706 46.2422 47.5734 46.2422H65.3916C66.0945 46.2422 66.6643 45.6723 66.6643 44.9695C66.6643 44.2666 66.0945 43.6968 65.3916 43.6968Z",
    fill: "#AFAFE9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.4825 51.3333H87.028C88.4338 51.3333 89.5735 52.473 89.573 53.8787V64.0605C89.573 65.4663 88.4334 66.606 87.0276 66.606H84.4821V83.1515C84.4821 83.8543 83.9122 84.4242 83.2094 84.4242C82.5065 84.4242 81.9367 83.8544 81.9367 83.1515V66.606H79.3912V85.6969C79.3912 86.3997 78.8215 86.9695 78.1185 86.9695C77.4157 86.9695 76.8458 86.3998 76.8458 85.6969V66.606H74.3004V78.0605C74.3004 78.7634 73.7305 79.3332 73.0277 79.3332C72.3248 79.3332 71.755 78.7635 71.755 78.0605V66.606H69.2095V75.5151C69.2095 76.218 68.6397 76.7878 67.9368 76.7878C67.234 76.7878 66.6641 76.2181 66.6641 75.5151V66.606H62.846V83.1515C62.846 83.8543 62.2761 84.4242 61.5733 84.4242C60.8704 84.4242 60.3006 83.8544 60.3006 83.1515V66.606H56.4824V85.6969C56.4824 86.3997 55.9126 86.9695 55.2097 86.9695C54.5069 86.9695 53.937 86.3998 53.937 85.6969V66.606H51.3916V72.9697C51.3916 73.6725 50.8218 74.2423 50.1189 74.2423C49.416 74.2423 48.8462 73.6726 48.8462 72.9697V66.606H46.3007V80.606C46.3007 81.3088 45.731 81.8787 45.028 81.8787C44.3252 81.8787 43.7553 81.309 43.7553 80.606V66.606H41.2098V88.2425C41.2098 88.9453 40.64 89.5151 39.9371 89.5151C39.2343 89.5151 38.6645 88.9454 38.6645 88.2425V66.6061H36.119C34.7132 66.6061 33.5735 65.4664 33.5735 64.0606V53.8788C33.5735 52.473 34.7132 51.3333 36.119 51.3333H38.6643V36.0606C38.6643 34.6548 39.804 33.5151 41.2098 33.5151H74.3008L84.4825 43.697V51.3333ZM80.6644 43.6971L74.3007 37.3334V43.6971H80.6644ZM41.21 36.0605H71.7554V44.9697C71.7554 45.6726 72.3253 46.2424 73.0281 46.2424H81.9373V51.3332H41.21V36.0605ZM36.1189 64.0607H87.0279H87.028V53.8789H36.1189V64.0607Z",
    fill: "#3030AD"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_3",
    cx: 45.0281,
    cy: 58.9695,
    r: 1.27269,
    fill: "#AFAFE9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_4",
    cx: 39.9372,
    cy: 58.9695,
    r: 1.27269,
    fill: "#AFAFE9"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShreder2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/shreder2.56cc8fa39bdeae68a0a7d0c2e8235107.svg";